window.EEOQuestionsCandidateForm = function (scope, brandId, jobId) {
    const self = this;
    const formName = "eeo-questions-candidate-form";
    const _protected = BaseForm.call(self, formName, scope);

    if (jobId) {
        self.jobId = jobId;
    }

    if (brandId) {
        self.brandId = brandId;
    }

    self.countries = window.countries;

    self.load = (formData) => {
        self.allQuestions = JSON.parse(JSON.stringify(formData.questions));
        self.formType = formData.type;
        self.questions = self.allQuestions.filter(question => !question.show_if?.length);

        prepareQuestionToView(self.questions);
    };

    self.onAnswerChanged = (question) => {
        self.allQuestions.forEach(item => {
            const showIfCondition = item?.show_if?.[0];
            const questionMatches = question.id === showIfCondition?.question_id;
            const answerMatches = question.answers?.selected_choice_id === showIfCondition?.choice_id;
            const answers = {};

            if (showIfCondition && questionMatches) {
                if (answerMatches) {
                    const newQuestion = JSON.parse(JSON.stringify(item));

                    if (item.type === 'single_choice') {
                        answers.selected_choice_id = item.answers?.[0]?.question_choice_id;
                        newQuestion.answers = answers;
                    }

                    self.questions.splice(newQuestion.order - 1, 0, newQuestion);
                } else {
                    self.questions = self.questions.filter(q =>
                        q.show_if?.[0]?.question_id !== question.id ||
                        q.show_if?.[0]?.choice_id === question.answers?.selected_choice_id
                    );
                }

                const standardQuestions = self.questions.filter(question => question.mode === 'SYSTEM');
                const customQuestions = self.questions.filter(question => question.mode === 'CUSTOM');

                standardQuestions.sort((question1, question2) => question1.order - question2.order);
                self.questions = [...standardQuestions, ...customQuestions];
            }
        });
    };

    const prepareQuestionToView = (formQuestions) => {
        formQuestions.forEach((question) => {
            const answers = {};

            if (!question.answers?.length) {
                if (question.type === 'single_choice') {
                    answers.selected_choice_id = undefined;
                }
            } else {
                if (question.type === 'single_choice') {
                    answers.selected_choice_id = question.answers[0]?.question_choice_id;
                    question.answers = answers;

                    self.onAnswerChanged(question);
                } else if (question.type === 'multiple_choice') {
                    question.answers.forEach(answer => {
                        answers[answer.question_choice_id] = {};
                        answers[answer.question_choice_id].selected = true;
                        question.answers = answers;
                    });
                } else if (['date', 'country_list'].includes(question.type)) {
                    answers[question.id] = {};
                    answers[question.id].answer_text = question.answers[0]?.answer_text;
                    question.answers = answers;
                }
            }
        });
    };

    const prepareQuestionsToSave = () => {
        let payload = {
            opted_out: false,
            answers: []
        };

        for (const i in self.questions) {
            const question = self.questions[i];

            if (question.type === "multiple_choice") {
                for (const choiceId in question.answers) {
                    const answerChoice = question.answers[choiceId];

                    if (answerChoice?.selected) {
                        payload.answers.push({
                            question_id: question.id,
                            question_choice_id: parseInt(choiceId)
                        });
                    }
                }
            } else if (question.type === "single_choice") {
                if (question.answers?.selected_choice_id) {
                    payload.answers.push({
                        question_id: question.id,
                        question_choice_id: question.answers.selected_choice_id
                    });
                }
            } else if (['date', 'country_list'].includes(question.type)) {
                if (question.answers?.[question.id]?.answer_text) {
                    payload.answers.push({
                        question_id: question.id,
                        answer_text: question.answers[question.id].answer_text
                    });
                }
            }
        }

        return payload;
    };

    self.save = () => {
        const payload = prepareQuestionsToSave();
        return EEOAPI.updateEeoQuestionsCandidateSettings(self.brandId, self.formType, payload);
    };

    self.optOutEEOForm = () => {
        const payload = {
            opted_out: true,
        };
        return EEOAPI.updateEeoQuestionsCandidateSettings(self.brandId, self.formType, payload);
    };
};